export default "__VITE_ASSET__DACOAgrO__"